// extracted by mini-css-extract-plugin
export default {"createShowcaseContainer":"styles_createShowcaseContainer__xq+nI","showcaseStep":"styles_showcaseStep__O-gge","footerButtons":"styles_footerButtons__IDOt7"};